export default {
    namespaced: true,
    state: {
        zIndex: 50,
    },
    mutations: {
        setzIndex(state, zIndex) {
            state.zIndex = zIndex < 50 ? 50 : zIndex;
        },
    },
};
